import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { locations } from '../routes/locations';
import packageJson from '../../package.json';

export default function PublicPageLayout() {
  const { pathname } = useLocation();
  /**
   * Login is a two-column split, so a bar centred across the full width lands on
   * the seam. That page renders the version inside its own form column instead.
   */
  const ownsVersionLabel = pathname === locations.login();

  return (
    <>
      <Outlet />
      {!ownsVersionLabel && (
        <Box display="flex" alignItems="center" justifyContent="center" bottom="0" position="absolute" width="100%">
          <Typography variant="body2">Version: {packageJson.version}</Typography>
        </Box>
      )}
    </>
  );
}
